import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'RecommendedAnswers',
  properties: {
    referencedAnswerId: String,
  },

  statics: {
    breadcrumb: 'Suggested Answers',
  },
});
